'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
    async getCommissionRates() {
        const data = {
            method: 'get',
            url: 'commission-rates',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createCommissionRate(json) {
        const data = {
            method: 'post',
            url: 'commission-rate',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Commission Rate created successfully')
            return true;
        }
    },
    async updateCommissionRate(json, id) {
        const data = {
            method: 'patch',
            url: 'commission-rate/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Commission Rate updated successfully')
            return true;
        }
    },
}
